import { projects } from "./projects";

// Derived only from real data, so the numbers stay honest as content changes.
const CAREER_START = new Date(2022, 0, 1); // Jan 2022, first role at Avanexa Technology

export const yearsExperience = () => {
  const ms = Date.now() - CAREER_START.getTime();
  return Math.max(1, Math.floor(ms / (365.25 * 24 * 60 * 60 * 1000)));
};

export const stats = () => [
  {
    value: `${projects.filter((p) => !p.inProgress).length}`,
    label: "Shipped projects",
  },
  {
    value: `${projects.filter((p) => p.playUrl).length}`,
    label: "Live on Google Play",
  },
  { value: `${yearsExperience()}+`, label: "Years building products" },
];
